import { Button, Col, Row, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TaskViewViewModel } from 'src/pages/TasksPage/TaskViewViewModel';
import styled from 'styled-components';

export const BOTaskViewHeader = observer(() => {
    const assigned = Boolean(TaskViewViewModel.taskDefinition?.assignee);
    const { t } = useTranslation();

    if (!TaskViewViewModel.taskDefinition) {
        return null;
    }
    const { taskDefinition } = TaskViewViewModel;

    const hasL10nTitleKey = Boolean(taskDefinition.extensions?.l10nTitleKey);
    const title = hasL10nTitleKey
        ? t(`${taskDefinition.extensions?.l10nTitleKey}`, {
              ...taskDefinition?.taskInfo,
          })
        : taskDefinition.name;

    return (
        <StyledHeaderRow
            gutter={10}
            wrap={false}
            align="middle"
            data-testid="tasks-item-header"
        >
            <Col flex={1}>
                <StyledTitlte data-testid="tasks-item-header-title">
                    {title}
                </StyledTitlte>
            </Col>
            <Col>
                {assigned ? (
                    <StyledButtonCancel
                        onClick={() => {
                            TaskViewViewModel.unclaim(
                                TaskViewViewModel.taskDefinition?.id,
                            );
                        }}
                        data-testid="tasks-item-header-cancel-btn"
                    >
                        {t('Page.Tasks.TaskView.Cancel', {
                            defaultValue: 'Cancel',
                        })}
                    </StyledButtonCancel>
                ) : (
                    <StyledButton
                        type="primary"
                        data-testid="tasks-item-header-claim-btn"
                        onClick={() => {
                            TaskViewViewModel.claim(
                                TaskViewViewModel.taskDefinition?.id,
                            );
                        }}
                    >
                        {t('Page.Tasks.TaskView.Claim', {
                            defaultValue: 'Claim',
                        })}
                    </StyledButton>
                )}
            </Col>
        </StyledHeaderRow>
    );
});

const StyledButton = styled(Button)`
    background: var(--btn-bg);
    border-radius: 0.5rem;
    width: 8.6rem;
    height: 2.7rem;
    padding: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledButtonCancel = styled(Button)`
    color: white;
    background: var(--btn-bg);
    border-radius: 0.5rem;
    width: 8.6rem;
    height: 2.7rem;
    border-color: var(--btn-bg);
    padding: inherit;
    display: flex;
    justify-content: center;
    align-items: center;

    &:active,
    &:focus,
    &:hover {
        background: var(--btn-bg-hover);
        border-color: var(--btn-bg-hover);
        color: white;
        border-color: transparent;
    }
`;

const StyledHeaderRow = styled(Row)`
    margin-bottom: 1.8rem;
`;

const StyledTitlte = styled(Typography.Title)`
    padding-left: 1.6rem;
    margin-bottom: 0 !important;
`;
